<template>
    <v-col class="text-input">
        <div 
            v-if="label"
            class="label pl-3 pb-3 text small weight-500 text-grey-color"
        >
            {{ label }}
        </div>
        <v-text-field
            class="macInput"
            hide-details
            :type="inputType"
            v-model="model"
            :label="placeholder"
            single-line
            :outlined="outlined"
            :prepend-inner-icon="icon"
            @change="$emit('changed')"
        ></v-text-field>
    </v-col>
</template>

<script type="text/javascript">
  export default {
    props: {
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      inputType: {
        type: String,
        default: '',
      },
      outlined: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        message: "",
      }
    },
    computed: {
      model: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>


<style lang="scss">
    
    .text-input {
      .v-icon{ 
          color: $green-checked !important;
      }
      .v-input__slot fieldset {
        color: transparent !important;
      }
      .macInput {
        background-color: $pure-white !important;
        border: none !important;
        border: 2px solid $blue-light-border !important;
      }
    }

</style>